import { Badge } from '@postscript/components';
import React from 'react';

export type EnumChipVariant =
  | 'neutral'
  | 'info'
  | 'success'
  | 'warning'
  | 'error';

interface EnumChipProps {
  children: React.ReactNode;
  variant?: EnumChipVariant;
}

// Display-cased label rendered as a Badge. Callers pass the already-cased
// string (via the display* maps in copy.ts) so this component stays presentation-only.
// Defaults to the blue `info` variant to match the Message Inputs chips in Figma.
export const EnumChip: React.FC<EnumChipProps> = ({
  children,
  variant = 'info',
}) => (
  <Badge variant={variant} size="small">
    {children}
  </Badge>
);
